<template>
<div>
    <p style="padding: 12px;">
        Before you invite your Team, you can create User Groups to decide 
        what kind of documents your Team members will have access to. 
        </br> We have made two default groups to get you started, 
        a  restricted group for "Management"  and one that "All users" will be part of. 
    </p>

    <groups
        ref='groups'
        :styles='styles'
        :groups='allGroups'
        :all-users='allUsers'
        :all-categories='allCategories'
        :allow-user-selection='false'
        :maxDepth='0'

        @creategroup='onCreateGroup'
        @updategroup='onUpdateGroup'
    />

    <div class="bottom-action">
        <button class="continue simple" @click='updatePendingGroups'>Continue</button>
    </div>

</div>
</template>

<script>
import { mapState } from 'vuex'
import { loading } from '@/account/utils'
export default {
    data() {
        return {
            styles: {
                row: '',
                groups: 'unit one-third',
                container: 'grid',
                categories: 'unit two-thirds'
            },
            allUsers: [],
            newGroups: [],
            updatedGroups: []
        }
    },

    created () {

        this.$store.dispatch('getAllCategories').then(() => {
            this.$store.dispatch('getAllGroups')
            this.allUsers = [this.$store.state.currentUser]
        })
    },

    computed: {
        ...mapState({
            allGroups: 'groups',
            allCategories: 'categories'
        })
    },

    methods: {
        updatePendingGroups: loading(function updatePendingGroups () {
            var requestPromises = []

            if(this.newGroups.length) {
                this.newGroups.forEach(group => {
                    requestPromises.push(this.$store.dispatch('createGroup', group))
                })
                this.newGroups = []
            }

            if(this.updatedGroups.length) {
                this.updatedGroups.forEach(group => {
                    requestPromises.push(this.$store.dispatch('updateGroup', group))
                })
                this.updatedGroups = []
            }

            return Promise.all(requestPromises)
                .then(() => {
                    this.$store.commit('next')
                })
                .catch((err) => {
                    console.error(err)
                    this.$store.dispatch('error', 'Something went wrong. Try again later.')
                })
        }),
        onCreateGroup (data) {
            this.newGroups[data.id] = data
        },
        onUpdateGroup(data) {

            const isNewGroup = !!this.newGroups[data.id]
            if (isNewGroup) {
                this.newGroups[data.id] = data
            } else {
                this.updatedGroups[data.id] = data
            }
        }
    }
}
</script>

<style lang='scss'>

// TODO: (MOIN) web-components style override
// probably should be in the compoents
.setup-user-groups .create-group {
  min-height: 50px;

  input {
    width: 200px;
    display: inline-block;

    border-color: #e0e0e0;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;

    &:focus {
      border-color: #e0e0e0;
    }
  }

  button {
    height: 34px;
    min-width: 35px;
    border-radius: 0;

    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;

    &:hover {
      transform: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// apps/account/Groups.vue